// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { fontConfig } from "@stoneage/XDL/constants";
import { xBaseTheme } from "@stoneage/XDL/types";
import { color, xScreen } from "@stoneage/XDL/Utilities";
import { styledScrollbar } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";
import { ButtonIcon } from "@insite/mobius/Button";

export default {
    sizeVariants: {
        small: 480,
        medium: 600,
        large: 1110,
    },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        closeButtonProps: {
            mergeCss: true,
            css: css`
                &&& {
                    position: absolute;
                    padding: 0 0;
                    border: 0;
                    box-shadow: none;
                    width: 24px;
                    height: 24px;
                    right: -10px;
                    top: -10px;
                    border-radius: 0;
                    border-color: transparent;
                    background-color: transparent;
                    min-height: 24px;
                    display: flex;
                    justify-content: center;

                    ${ButtonIcon} {
                        color: ${color("primary")};
                    }

                    &:hover,
                    &:focus {
                        background-color: transparent;
                        ${ButtonIcon} {
                            color: ${color("primary")};
                        }
                    }
                    span:nth-child(3) {
                        display: none;
                    }
                }
            `,
        },
        cssOverrides: {
            modalContainer: css``,
            modalBody: css`
                background-color: ${color("common.white")};
                &&&&&& {
                    box-shadow:
                        0 0 0 1px ${color("common.ui5")},
                        0 2px 2px 0 ${color("secondary", 0.33)};
                }
                overflow: visible;
                ${xScreen("lte", "md")} {
                    max-width: 90%;
                    height: auto;
                    max-height: calc(100% - 32px);
                    margin: 16px;
                }
            `,
            headlineTypography: css`
                margin-bottom: 0;
                letter-spacing: 0;
            `,
            modalTitle: css`
                padding: 16px;
                color: ${color("secondary")};
                background-color: ${color("common.white")};
                border: 0;
            `,
            modalContent: css`
                padding: 0 16px 16px;
                color: ${color("text")};
                line-height: ${fontConfig.regular.lineHeight};
                ${styledScrollbar()}
            `,
        },
        headlineTypographyProps: {
            variant: "h3",
            css: css`
                margin-bottom: 0;
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: "IconModalClose",
            size: 24,
        },
    },
} as xBaseTheme["modal"];
